export const DYNAMIC_REPORTS_REPORT_ID = 'dynamic-reports';
